import {
	Object3D,
} from "three";

/**
 * Defines a displayable model, which contains a root node and optionally extra information.
 */
export class Web3dModel<T>
{
	/**
	 * The object used to display this model.
	 */
	public readonly object: Object3D;

	/**
	 * The optional extra information which may be represented by this model.
	 */
	public readonly extraInformation?: T;

	/**
	 * Constructs a new Model using the specified parameters.
	 *
	 * @param object the object used to display this model
	 * @param extraInformation optional extra information
	 */
	constructor(object: Object3D, extraInformation?: T)
	{
		this.object = object;
		this.extraInformation = extraInformation;
	}
}
